import React, { useMemo } from "react";
import styled from "styled-components";

import { getStaticUrl } from "js/config";
import ProgressBar from "js/react/components/ProgressBar";

import { TeamCheckoutSteps } from "../../TeamCheckoutFlow";
import { t } from "js/i18n";
const Container = styled.div`
    display: flex;
    padding: 20px;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    align-self: stretch;
`;

const ProgressWrapper = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const BeautifulLogo = styled.img`
    width: 100px;
`;

const StepLabel = styled.div`
    color: #000;
    flex: 0 0 auto;
    white-space: nowrap;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
    letter-spacing: -0.32px;
`;

interface FlowProgressProps {
    step: string;
    steps?: string[];
    showStepLabel?: boolean;
}

export default function FlowProgress({ step, steps, showStepLabel = false }: FlowProgressProps) {
    const stepArray = steps ?? Object.values(TeamCheckoutSteps);

    const { prevProgress, progress } = useMemo(() => {
        const prevStepIndex = Math.max(0, stepArray.indexOf(step) - 1);
        const stepIndex = Math.min(stepArray.length, stepArray.indexOf(step) + 1);

        const prevProgress = (prevStepIndex / stepArray.length) * 100;
        const progress = (stepIndex / stepArray.length) * 100;

        return { prevProgress, progress };
    }, [step, stepArray]);

    const { currentStepNumber, totalSteps } = useMemo(() => {
        const currentStepNumber = stepArray.indexOf(step) + 1;
        const totalSteps = stepArray.length;
        return { currentStepNumber, totalSteps };
    }, [step, stepArray]);

    return (
        <Container>
            {showStepLabel && (
                <StepLabel>
                    <span>
                        {t("Step {{currentStepNumber}} of {{totalSteps}}", { currentStepNumber, totalSteps })}
                    </span>
                </StepLabel>
            )}
            <ProgressWrapper>
                <ProgressBar prevProgress={prevProgress} progress={progress} />
            </ProgressWrapper>
            <LogoWrapper>
                <BeautifulLogo src={getStaticUrl("/images/beautifulai-logos/beautifulai-logo.svg")} alt="Beautiful Logo" />
            </LogoWrapper>
        </Container>
    );
}
